import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { catchError, map } from 'rxjs/operators'
import { Observable, throwError } from 'rxjs'
import { BehaviorSubject } from 'rxjs'
import { lowercaseKeys } from './utils'
// import { Http, Response, Headers, RequestOptions } from "@angular/http";

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  base_url1 = 'https://localhost:7222/api/'
  base_url3 = 'https://localhost:44373/api/'
  base_url = 'https://retailpos.azurewebsites.net/api/'
  base_url2 = 'https://biz1ps.azurewebsites.net/api/'
  // biz1_sap = 'https://localhost:44334/api/'
  server_ip = 'http://localhost'
  dburl = 'http://localhost:8081/'
  biz1_sap = 'https://uat-retailpos.azurewebsites.net/api/'
  b1z1SapPOS = 'https://uat-bizpos.azurewebsites.net/api/'
local_url='https://uat-bizpos.azurewebsites.net/api/biz1book_web/'
  localurl= 'https://localhost:44348/api/biz1book_web/'
  taskurl = 'https://uat-bizpos.azurewebsites.net/api/biz1book_web/'
  local_url_1 = 'https://localhost:44348/api/biz1book_web/'
  prd: any
  showInactive: any
  searchText: any

  constructor(private http: HttpClient) {}
  public storeid: BehaviorSubject<number> = new BehaviorSubject<number>(0)
  public contactid: BehaviorSubject<number> = new BehaviorSubject<number>(0)

  toFormData(formValue) {
    const formData = new FormData()
    for (const key of Object.keys(formValue)) {
      const value = formValue[key]
      // console.log(key, value)
      formData.append(key, value)
    }
    return formData
  }

  //Company

  CheckProdStatus(ProdID) {
    return this.http.get(this.b1z1SapPOS + 'POSOrder/ActiveChecker?ProductId=' + ProdID)
  }

  GetCompanyDet(CompanyId) {
    return this.http.get(this.biz1_sap + 'Company/GetCompanyIndex?companyId=' + CompanyId)
  }

  SaveCompany(formdata) {
    var body = this.toFormData(formdata)
    return this.http.post(this.biz1_sap + 'Company/SaveData', body)
  }

  //Customer

  SaveCustomer(payload) {
    return this.http.post(this.base_url + 'Company/AddCustomer', payload)
  }

  CustomerIndex(compid) {
    return this.http.get(this.base_url + 'Company/Customer_Index?compid=' + compid)
  }

  CustomerDetails(custid) {
    return this.http.get(this.base_url + 'Company/CustomerDetailsIndex?custid=' + custid)
  }

  deletecustomer(payload) {
    return this.http.post(this.base_url + 'Company/DeleteCustomer', payload)
  }

  UpdateCustomerErp(payload) {
    return this.http.post(this.base_url + 'Company/UpdateCustomer', payload)
  }

  //Bank Account

  AddbankAccount(data) {
    return this.http.post(this.base_url + 'Company/AddBankaccount', data)
  }

  GetBankAccounts(companyId) {
    return this.http.get(this.base_url + 'Company/GetBankAccounts?companyId=' + companyId)
  }

  UpdateBankAccount(data) {
    return this.http.post(this.base_url + 'Company/updateBankAcc', data)
  }

  //Deposit & Withdrawal

  BankDepDrawIndex(
    compid,
    transtype,
    transmode,
    amtstr,
    amtend,
    respid,
    multiact,
    frmdate,
    todate,
    storeid,
    type,
  ) {
    return this.http.get(
      this.base_url +
        'ERP/bankdepwithdrawIndex?compid=' +
        compid +
        '&transtype=' +
        transtype +
        '&transmode=' +
        transmode +
        '&amtstr=' +
        amtstr +
        '&amtend=' +
        amtend +
        '&respid=' +
        respid +
        '&multiact=' +
        multiact +
        '&frmdate=' +
        frmdate +
        '&todate=' +
        todate +
        '&storeid=' +
        storeid +
        '&type=' +
        type,
    )
  }

  savedepwithdraw(payload) {
    return this.http.post(this.base_url + 'ERP/SaveDepWithdraw', payload)
  }

  DeleteDepwithdraw(transid, transmode, balance, contact) {
    return this.http.get(
      this.base_url +
        'ERP/DeleteDepwithdraw?transid=' +
        transid +
        '&transmode=' +
        transmode +
        '&balance=' +
        balance +
        '&contact=' +
        contact,
    )
  }

  UpdateBankDepwithDraw(payload) {
    return this.http.post(this.base_url + 'ERP/UpdateBankDepwithDraw', payload)
  }

  //Money Transfer

  GetAllBankAccount() {
    return this.http.get(this.base_url + 'ERP/GetAllBankAccounts')
  }

  SaveMoneytrans(payload) {
    return this.http.post(this.base_url + 'ERP/SaveAccount', payload)
  }

  GetBankTransIndex(CompanyId, StoreId) {
    return this.http.get(
      this.base_url + 'ERP/GetBankTransIndex?companyId=' + CompanyId + '&storeId=' + StoreId,
    )
  }

  GetBankTransDetails(TransId) {
    return this.http.get(this.base_url + 'ERP/GetBankTransDetails?TransId=' + TransId)
  }

  UpdatedBankTrans(payload) {
    return this.http.post(this.base_url + 'ERP/SaveEditBankTrans', payload)
  }

  //Swiping Machine

  SaveSwipeMachine(payload) {
    return this.http.post(this.base_url + 'Company/SaveSwipMachine', payload)
  }
  GetSwipeMachine(companyId, storeId, accno, machid) {
    return this.http.get(
      this.base_url +
        'Company/GetSwipeMachineIndex?companyId=' +
        companyId +
        '&storeId=' +
        storeId +
        '&accNo=' +
        accno +
        '&machId=' +
        machid,
    )
  }
  GetEditSwipe(astId) {
    return this.http.get(this.base_url + 'Company/EditByIdSwipe?astId=' + astId)
  }
  UpdateSwipe(payload) {
    return this.http.post(this.base_url + 'Company/SaveEditSwipe', payload)
  }
  ActiveAsset(astId) {
    return this.http.get(this.base_url + 'Company/AssetAct?Id=' + astId)
  }

  //Payment Type

  GetPayment(CompanyId) {
    return this.http.get(this.biz1_sap + 'PaymentType/GetPaymentTypeIndex?CompanyId=' + CompanyId)
  }

  AddPaymentTypes(payment) {
    return this.http.post(this.biz1_sap + 'PaymentType/AddPaymentTypes', payment)
  }

  UpdatePaymentTypes(payment) {
    return this.http.post(this.biz1_sap + 'PaymentType/UpdatePaymentType', payment)
  }

  PaymentisActive(paymentid) {
    return this.http.get(this.biz1_sap + 'PaymentType/PaymentTypeActive?paymentid=' + paymentid)
  }

  //Asset

  GetAssets(companyId, vendorId, asttypeId, storeId, asset) {
    return this.http.get(
      this.base_url +
        'Company/GetAssets?companyId=' +
        companyId +
        '&vendorId=' +
        vendorId +
        '&asttypeId=' +
        asttypeId +
        '&storeId=' +
        storeId +
        '&asset=' +
        asset,
    )
  }

  AddAssets(data) {
    return this.http.post(this.base_url + 'Company/AddAssets', data)
  }

  UpdateAssets(data) {
    return this.http.post(this.base_url + 'Company/updateAsset', data)
  }

  GetAstTypes(companyId) {
    return this.http.get(this.base_url + 'Company/GetAstTypes?companyId=' + companyId)
  }

  GetAsTypeIsActive(id) {
    return this.http.get(this.base_url + 'Company/Ass_TypeDeactive?id=' + id)
  }

  GetAstDeactive(id) {
    return this.http.get(this.base_url + 'Company/AssetDeactive?id=' + id)
  }

  GetAssetDelete(id) {
    return this.http.get(this.base_url + 'Company/AssetDelete?id=' + id)
  }

  GetAssetTypeDelete(id) {
    return this.http.get(this.base_url + 'Company/AssetTypeDelete?id=' + id)
  }

  //Asset Type

  GetAssetTypes(companyId) {
    return this.http.get(this.base_url + 'Company/GetAssettypes?companyId=' + companyId)
  }

  AddAssetTypes(data) {
    return this.http.post(this.base_url + 'Company/AddAssettypes', data)
  }
  UpdateAssetTypes(data) {
    return this.http.post(this.base_url + 'Company/Updateassettypes', data)
  }

  //Maintanance

  Getmaintanance(CompanyId, storeId, asset, vendor, assetType, Mainttype, indexType) {
    return this.http.get(
      this.base_url +
        'Company/Getmaintanance?companyId=' +
        CompanyId +
        '&storeId=' +
        storeId +
        '&asset=' +
        asset +
        '&vendor=' +
        vendor +
        '&assetType=' +
        assetType +
        '&Mainttype=' +
        Mainttype +
        '&indexType=' +
        indexType,
    )
  }

  GetBills(companyId, date, asset, vendor, storeId) {
    return this.http.get(
      this.base_url +
        'Company/GetBills?companyId=' +
        companyId +
        '&date=' +
        date +
        '&asset=' +
        asset +
        '&vendor=' +
        vendor +
        '&storeId=' +
        storeId,
    )
  }

  Updatebills(payload) {
    return this.http.post(this.base_url + 'Company/UpdateBills', payload)
  }

  GetAst(companyId, storeId) {
    return this.http.get(
      this.base_url + 'Company/GetAst?companyId=' + companyId + '&StoreId=' + storeId,
    )
  }

  GetMaintBillById(MBTid) {
    return this.http.get(this.base_url + 'Company/GetAstByMaintBillId?MaintBillId=' + MBTid)
  }
  DeleteGBills(payload) {
    return this.http.post(this.base_url + 'Company/DeleteGeneratedBill', payload)
  }

  GetCompanyAst(companyId) {
    return this.http.get(this.base_url + 'Company/GetCompanyAst?companyId=' + companyId)
  }

  AddMaintBill(payload) {
    return this.http.post(this.base_url + 'Company/AddMaintbill', payload)
  }

  Getmaintbilltypes(companyId) {
    return this.http.get(this.base_url + 'Company/Getmaintbilltype?companyId=' + companyId)
  }

  Generatebills(payload) {
    return this.http.post(this.base_url + 'Company/Generatebills', payload)
  }

  AddMaintanance(payload) {
    return this.http.post(this.base_url + 'Company/AddMaintanance', payload)
  }

  UpdateMaintBill(payload) {
    return this.http.post(this.base_url + 'Company/UpdateMaintBill', payload)
  }

  GetAssettypebyasset(astTypeId) {
    return this.http.get(this.base_url + 'Company/GetAsttypebyAst?astTypeId=' + astTypeId)
  }

  //Maintanance Bill Type
  getmaintbill(CompanyId) {
    return this.http.get(this.base_url + 'Company/GetMaintBillTypes?companyId=' + CompanyId)
  }

  SaveMaintbill(maintBillType) {
    return this.http.post(this.base_url + 'Company/AddMaintBillType', maintBillType)
  }

  GetDeactivate(Id) {
    return this.http.get(this.base_url + 'Company/Deactivate?id=' + Id)
  }

  GetMaintBillTypeById(Id) {
    return this.http.get(this.base_url + 'Company/GetMaintBillTypeById?id=' + Id)
  }

  UpdateMaintbill(maintBillType) {
    return this.http.post(this.base_url + 'Company/UpdateMaintBillType', maintBillType)
  }

  //Purchase&Maintanance

  PurchaseMaintIndex(
    billtype,
    billstatus,
    compid,
    billid,
    vendorid,
    paylocid,
    recloc,
    frmdate,
    todate,
    amtstr,
    amtend,
  ) {
    return this.http.get(
      this.base_url +
        'ERP/PurchaseMaintIndex?billtype=' +
        billtype +
        '&billstatus=' +
        billstatus +
        '&compid=' +
        compid +
        '&billid=' +
        billid +
        '&vendorid=' +
        vendorid +
        '&amtstr=' +
        amtstr +
        '&amtend=' +
        amtend +
        '&frmdate=' +
        frmdate +
        '&todate=' +
        todate +
        '&paylocid=' +
        paylocid +
        '&recloc=' +
        recloc,
    )
  }

  GetReferenceList(compid) {
    return this.http.get(this.base_url + 'ERP/GetReferenceList?compid=' + compid)
  }

  GetStorePaymentType(compid, storeid) {
    return this.http.get(
      this.base_url + 'ERP/GetStorePaymentType?compid=' + compid + '&storeid=' + storeid,
    )
  }

  SavePurchMaintBill(payload) {
    return this.http.post(this.base_url + 'ERP/SavePurchMaintBill', payload)
  }

  BillPayTransValues(billid) {
    return this.http.get(this.base_url + 'ERP/BillPayTransValues?billid=' + billid)
  }

  BillPaySingleTrans(transId) {
    return this.http.get(this.base_url + 'ERP/BillPaySingleTrans?transId=' + transId)
  }

  EditPurchaseMaint(payload) {
    return this.http.post(this.base_url + 'ERP/EditPurchaseMaint', payload)
  }

  EditpayTansDelete(transid, billid, orderid, BankId) {
    return this.http.get(
      this.base_url +
        'ERP/DeleteTransBillPay?transid=' +
        transid +
        '&billid=' +
        billid +
        '&orderid=' +
        orderid +
        '&BankId=' +
        BankId,
    )
  }

  //Dayclosing
  Gettranstypes(companyId, storeId, date) {
    return this.http.get(
      this.base_url +
        'Store/GetOnlineAssets?companyId=' +
        companyId +
        '&storeId=' +
        storeId +
        '&date=' +
        date,
    )
  }
  GetPoscash(storeid, date) {
    return this.http.get(
      this.base_url + 'Store/GetPOSDayClosing?storeId=' + storeid + '&date=' + date,
    )
  }
  GetPOSPaymt(storeId, companyId, from, to) {
    return this.http.get(
      this.base_url2 +
        'Receipt/storepaymentsbytype?storeid=' +
        storeId +
        '&companyid=' +
        companyId +
        '&from=' +
        from +
        '&to=' +
        to,
    )
  }

  GetPOSspt(storeId) {
    return this.http.get(this.base_url2 + 'Receipt/spt?storeid=' + storeId)
  }

  SaveDayclosing(payload) {
    return this.http.post(this.base_url + 'Store/SaveDayClosing', payload)
  }

  // Cash Closing
  //AccountClosing
  GetAccountInd(companyId, storeId, date) {
    return this.http.get(
      this.base_url +
        'Company/GetAccountClosIndex?CompanyId=' +
        companyId +
        '&StoreId=' +
        storeId +
        '&Date=' +
        date,
    )
  }

  GetAccounttrans(companyId, storeId, date, paytypeid) {
    return this.http.get(
      this.base_url +
        'Company/GetAccountClosTrans?CompanyId=' +
        companyId +
        '&StoreId=' +
        storeId +
        '&Date=' +
        date +
        '&PaytypeId=' +
        paytypeid,
    )
  }

  GetClosingTrans(CompanyId, StoreId, Date) {
    return this.http.get(
      this.base_url +
        'Company/GetClosingTrans?CompanyId=' +
        CompanyId +
        '&StoreId=' +
        StoreId +
        '&Date=' +
        Date,
    )
  }

  SaveAccClosing(payload) {
    return this.http.post(this.base_url + 'Company/SaveAccountClosing', payload)
  }

  getBankClsng(CompanyId, StoreId, Date, PaytypeId) {
    return this.http.get(
      this.base_url +
        'Company/GetBankClosing?CompanyId=' +
        CompanyId +
        '&StoreId=' +
        StoreId +
        '&Date=' +
        Date +
        '&PaytypeId=' +
        PaytypeId,
    )
  }

  //Employee
  GetEmpRolesValues(compid) {
    return this.http.get(this.base_url + 'Menu/GetEmpRoles?compid=' + compid)
  }
  GetEmployeeIndex(
    compid,
    empid,
    empstoreid,
    empname,
    empdepart,
    empdegnt,
    emptoplist,
    empvisibility,
  ) {
    return this.http.get(
      this.base_url +
        'Menu/GetEmployeeIndex?compid=' +
        compid +
        '&empid=' +
        empid +
        '&empstoreid=' +
        empstoreid +
        '&empname=' +
        empname +
        '&empdepart=' +
        empdepart +
        '&empdegnt=' +
        empdegnt +
        '&emptoplist=' +
        emptoplist +
        '&empvisibility=' +
        empvisibility,
    )
  }

  Saveattancevalues(payload) {
    const formData: FormData = new FormData() // this.toFormData({ objData: payload })
    for (const key of Object.keys(payload)) {
      const value = payload[key]
      // console.log(key, value)
      formData.append(key, value)
    }
    let files: File[] = payload.fileList
    delete payload.fileList
    formData.append('image', files[0])
    formData.append('proof', files[1])
    // files.forEach(file => {
    //   formData.append('images[]', file)
    // })
    return this.http.post(this.base_url + 'Menu/AddEmployee', formData)
  }

  //Add Emp

  uploadImage(image: Blob): Observable<any> {
    const uploadEndpoint = 'https://biz1ps.azurewebsites.net/api/Product/koppupathivetram'
    const formData: FormData = new FormData()
    formData.append('file', image)

    return this.http.post(uploadEndpoint, formData)
  }

  GetEnumsHeaderValues() {
    return this.http.get(this.base_url + 'Menu/GetEnumsHeaderIndex')
  }

  GetEnumsValues(ColumnName) {
    return this.http.get(this.base_url + 'Menu/GetEnums?ColumnName=' + ColumnName)
  }

  updateempimgaes1(empid, imgurl) {
    return this.http.get(
      this.base_url + 'Menu/updateempimgaes1?empid=' + empid + '&imgurl=' + imgurl,
    )
  }

  updateempimgaes2(empid, proofurl) {
    return this.http.get(
      this.base_url + 'Menu/updateempimgaes2?empid=' + empid + '&proofurl=' + proofurl,
    )
  }

  EmployeeDetailsIndex(empid) {
    return this.http.get(this.base_url + 'Menu/EmployeeDetailsIndex?empid=' + empid)
  }

  GetStaDistEnumsHeaderIndex() {
    return this.http.get(this.base_url + 'Menu/GetStaDistEnumsHeaderIndex')
  }

  GetStaDistEnums(ColumnName) {
    return this.http.get(this.base_url + 'Menu/GetStaDistEnums?ColumnName=' + ColumnName)
  }

  getstores_emp(CompanyId) {
    return this.http
      .get(this.local_url + 'GetStoresUnique?companyId=' + CompanyId)
      .pipe(map(lowercaseKeys))
  }


  getstores_emp_NEW(CompanyId,ParentStoreId) {
    return this.http
      .get(this.local_url + 'GetStoresUnique_NEW?companyId=' + CompanyId +'&ParentStoreId='+ParentStoreId)
      .pipe(map(lowercaseKeys))
  }


  EmployeeDeginationsValues(emproleid) {
    return this.http.get(this.base_url + 'Menu/EmployeeDeginations?emproleid=' + emproleid)
  }

  //Edit Employee
  Employact(Id) {
    return this.http.get(this.base_url + 'Menu/EmployeAct?Id=' + Id)
  }
  GetEditEmp(Id) {
    return this.http.get(this.base_url + 'Menu/EmployeEditGet?Id=' + Id)
  }
  SaveEditEmp(payload) {
    return this.http.post(this.base_url + 'Menu/EditEmployeeSave', payload)
  }

  //Import Employee
  EXPO_EMPLOYEE(payload) {
    return this.http.post(this.base_url + 'Menu/ImportEmployees', payload)
  }

  //User

  GetRoleIndex() {
    return this.http.get(this.biz1_sap + 'User/GetRoles?companyId=')
  }

  GetuserIndex(CompanyId) {
    return this.http.get(this.biz1_sap + 'User/GetuserIndex?companyId=' + CompanyId)
  }

  AddUser_UpdatedUser(payload) {
    return this.http.post(this.biz1_sap + 'User/AddUser_UpdatedUsers', payload)
  }
  DeleteUser(Id) {
    return this.http.get(this.biz1_sap + 'User/Deleteuser?Id=' + Id)
  }

  GetEditUserById(Id) {
    return this.http.get(this.biz1_sap + 'User/GetUserById?id=' + Id)
  }

  // New Auth --> Start
  registration(payload) {
    return this.http.post(this.base_url + 'Login/Register', payload)
  }

  login(payload) {
    return this.http.post(this.local_url + 'LoginCheck', payload)
  }

  PinLogin(Pin, CompanyId) {
    return this.http
      .get(this.local_url + 'pinlogin?pin=' + Pin + '&companyid=' + CompanyId)
      .pipe(map(lowercaseKeys))
  }

  Lggetstore(CompanyId, StoreId, UserId) {
    return this.http.get(
      this.local_url + 'GetStores?companyId=' + CompanyId + '&id=' + StoreId + '&UserId=' + UserId,
    )
  }


  getstore(CompanyId, StoreId) {
    return this.http.get(this.local_url + 'GetStores?companyId=' + CompanyId + '&id=' + StoreId)
  }

  GetFactoryStores(CompanyId) {
    return this.http.get(this.local_url + 'GetFactoryStores?companyId=' + CompanyId)
  }

  GetProducts(CompanyId, StoreId) {
    return this.http.get(
      this.base_url + 'ERP/GetProducts?companyId=' + CompanyId + '&storeId=' + StoreId,
    )
  }

  //Internal Transfer Advance Search Q_02-11-2023

  GetIndexvalues(companyid, orderId, fromDate, toDate, supplierId, receiverId, orderStatusId) {
    return this.http.get(
      this.base_url +
        'ERP/GetInternalIndex?companyId=' +
        companyid +
        '&orderId=' +
        orderId +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        '&supplierId=' +
        supplierId +
        '&receiverId=' +
        receiverId +
        '&orderStatusId=' +
        orderStatusId,
    )
  }
  GetIndexvaluesdis(companyid, orderId, fromDate, toDate, supplierId, receiverId, orderStatusId) {
    return this.http.get(
      this.base_url +
        'ERP/GetInternalIndexDis?companyId=' +
        companyid +
        '&orderId=' +
        orderId +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        '&supplierId=' +
        supplierId +
        '&receiverId=' +
        receiverId +
        '&orderStatusId=' +
        orderStatusId,
    )
  }
  GetIndexvaluesrec(companyid, orderId, fromDate, toDate, supplierId, receiverId, orderStatusId) {
    return this.http.get(
      this.base_url +
        'ERP/GetInternalIndexRec?companyId=' +
        companyid +
        '&orderId=' +
        orderId +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        '&supplierId=' +
        supplierId +
        '&receiverId=' +
        receiverId +
        '&orderStatusId=' +
        orderStatusId,
    )
  }

  EditInternal(oid, cid, data) {
    return this.http.post(this.base_url + 'ERP/oi_update_Ord?oid=' + oid + '&cid=' + cid, data)
  }

  // --Internal new
  GetInternalValues(ordId) {
    return this.http.get(this.base_url + 'ERP/GetInternalValues?ordId=' + ordId)
  }

  UpdateInternalOrder(data) {
    return this.http.post(this.base_url + 'ERP/UpdateInternalOrder', data)
  }

  //---HYper's IO Edit

  GetDispatchedView(ordid) {
    return this.http.get(this.base_url + 'ERP/GetDispatchedView?ordid=' + ordid)
  }

  GetRecQtyValue(recQty) {
    return this.http.post(this.base_url + 'ERP/GetRecQtyValue', recQty)
  }

  getOIDispatch(oid) {
    return this.http.get(this.base_url + 'ERP/getOrderitems?oid=' + oid)
  }

  getproducts4update(cid) {
    return this.http.get(this.base_url + 'ERP/getProducts_4update?cid=' + cid)
  }

  saveDispatch(oid, cid, data) {
    return this.http.post(this.base_url + 'ERP/oi_update?oid=' + oid + '&cid=' + cid, data)
  }

  getOIDitem(oid) {
    return this.http.get(this.base_url + 'ERP/getoid_item?cid=' + oid)
  }

  deleteItem_hyper(ordid) {
    return this.http.get(this.base_url + 'ERP/GetDeleteOrder?ordid=' + ordid)
  }

  SaveIntOrd(payload) {
    return this.http.post(this.base_url + 'ERP/SaveInternal', payload)
  }

  GetOrderedProducts(CompanyId, StoreId) {
    return this.http.get(
      // this.base_url + 'ERP/GetDispatchProducts?companyId=' + CompanyId + '&storeId=' + StoreId,
      this.base_url + 'ERP/GetOrderedProducts?companyId=' + CompanyId + '&storeId=' + StoreId,
    )
  }

  GetDispatch(CompanyId, StoreId) {
    return this.http.get(
      this.base_url + 'ERP/GetDispatchProducts?companyId=' + CompanyId + '&storeId=' + StoreId,
    )
  }

  //DIspatch Index
  GetDispatchIndex(CompanyId, StoreId, OrdDate) {
    return this.http.get(
      this.base_url +
        'ERP/GetDispatchIndex?CompanyId=' +
        CompanyId +
        '&StoreId=' +
        StoreId +
        '&FromDate=' +
        OrdDate,
    )
  }

  GetOrdDetail(OrderId) {
    return this.http.get(this.base_url + 'ERP/GetOrderDetail?OrdId=' + OrderId)
  }

  SaveDisptach(OrderId) {
    return this.http.get(this.base_url + 'ERP/SaveDispatch?OrdId=' + OrderId)
  }

  GetReceive(CompanyId, StoreId) {
    return this.http.get(
      this.base_url + 'ERP/GetReceiveProd?companyId=' + CompanyId + '&storeId=' + StoreId,
    )
  }

  SaveReceive(OrderId) {
    return this.http.get(this.base_url + 'ERP/SaveReceive?OrdId=' + OrderId)
  }

  //PURCHASENTRY

  getbyid(OrdId) {
    return this.http.get(this.base_url + 'ERP/GetbyordId?OrdId=' + OrdId)
  }

  updatepurchase(payload) {
    return this.http.post(this.base_url + 'ERP/EditPurchase', payload)
  }

  Getvendors(CompanyId) {
    return this.http.get(this.base_url + 'Menu/getVendor_retail?companyId=' + CompanyId)
  }

  SavePurchase(payload) {
    return this.http.post(this.base_url + 'ERP/SavePurchase', payload)
  }

  Getstorepayment(StoreId) {
    return this.http.get(this.base_url + 'Menu/getStorePaymentType_Retail?storeId=' + StoreId)
  }

  GetProductspurchase(CompanyId) {
    return this.http.get(this.base_url + 'Menu/getProducts_retail?companyId=' + CompanyId)
  }

  Getpurchaseorder(CompanyId, StoreId) {
    return this.http.get(
      this.base_url + 'ERP/GetPurchaseOrder?companyId=' + CompanyId + '&storeid=' + StoreId,
    )
  }

  GetPurchaseReceivedorder(CompanyId, StoreId, date) {
    return this.http.get(
      this.base_url +
        'ERP/GetPurchaseReceivedOrder?companyId=' +
        CompanyId +
        '&storeid=' +
        StoreId +
        '&date=' +
        date,
    )
  }

  GetPurchaseordDet(OrderId) {
    return this.http.get(this.base_url + 'ERP/GetPurchaseordDet?OrdId=' + OrderId)
  }

  SaveBillReceive(OrdId) {
    return this.http.get(this.base_url + 'ERP/SaveReceivePurc?OrdId=' + OrdId)
  }

  deletepurchase(OrdId) {
    return this.http.get(this.base_url + 'ERP/deletepurchase?OrdId=' + OrdId)
  }

  DeleteReceiveOrd(payload) {
    return this.http.post(this.base_url + 'ERP/DeleteReceiveOrd', payload)
  }

  //BillPayByVendor

  GetBillPay(CompanyId, StoreId, VendId, FromAmt, ToAmount, fromdate, Todate, Billid, Billstatus) {
    return this.http.get(
      this.base_url +
        'ERP/GetBillPayVenInd?CompanyId=' +
        CompanyId +
        '&StoreId=' +
        StoreId +
        '&vendId=' +
        VendId +
        '&frmAmt=' +
        FromAmt +
        '&toAmt=' +
        ToAmount +
        '&frmdate=' +
        fromdate +
        '&todate=' +
        Todate +
        '&billid=' +
        Billid +
        '&billstatus=' +
        Billstatus,
    )
  }

  GetBillPayVenById(CompanyId, VendorId) {
    return this.http.get(
      this.base_url + 'ERP/GetBillPayVenById?companyId=' + CompanyId + '&vendorId=' + VendorId,
    )
  }

  SaveBillPay(payload) {
    return this.http.post(this.base_url + 'ERP/SaveBillByVend', payload)
  }

  GetEditBillPayVendor(CompanyId, TransId, VendorId) {
    return this.http.get(
      this.base_url +
        'ERP/GetEditBillPayVen?companyId=' +
        CompanyId +
        '&transId=' +
        TransId +
        '&vendorId=' +
        VendorId,
    )
  }

  SaveEditBillPayVendor(payload) {
    return this.http.post(this.base_url + 'ERP/EditBillPayVendor', payload)
  }

  getDeleteBillPayVend(TransId, CompanyId, Amount) {
    return this.http.get(
      this.base_url +
        'ERP/DeleteBillPayVend?transid=' +
        TransId +
        '&companyId=' +
        CompanyId +
        '&amount=' +
        Amount,
    )
  }

  //RECEIPT
  getInvoices2(companyid, storeid, fromdate, todate, startid, endid, invoice) {
    return this.http.get(
      this.base_url2 +
        'Receipt/Invoices2' +
        '?companyid=' +
        companyid +
        '&storeid=' +
        storeid +
        '&fromdate=' +
        fromdate +
        '&todate=' +
        todate +
        '&startid=' +
        startid +
        '&endid=' +
        endid +
        '&invoice=' +
        invoice,
    )
  }

  //GetReceiptDetails
  GetReceiptDetails(invoice, IsProd) {
    return this.http.get(
      this.base_url + 'ERP/GetReceiptDetails?invoice=' + invoice + '&IsProd=' + IsProd,
    )
  }

  //GET STORES
  getstores_temp(CompanyId) {
    return this.http.get(this.base_url + 'ERP/Getstore_temp?CompanyId=' + CompanyId)
  }

  //GET Companies
  getcom_temp() {
    return this.http.get(this.base_url + 'ERP/Getcom_temp')
  }

  //Attedance
  getemployee(CompanyId) {
    return this.http.get(this.base_url + 'Login/GetEmployee?companyId=' + CompanyId)
  }

  Saveatte(CompanyId, contid, date, IsCom, AttId, resid, res) {
    return this.http.get(
      this.base_url +
        'Login/SaveEmployee?companyId=' +
        CompanyId +
        '&contid=' +
        contid +
        '&date=' +
        date +
        '&IsCom=' +
        IsCom +
        '&AttId=' +
        AttId +
        '&resid=' +
        resid +
        '&res=' +
        res,
    )
  }

  Saveatte2(contactId, companyId, shift, reason, latereason) {
    return this.http.get(
      this.base_url +
        'Login/SaveAttendanceLogs?contactId=' +
        contactId +
        '&companyId=' +
        companyId +
        '&shift=' +
        shift +
        '&reason=' +
        reason +
        '&latereason=' +
        latereason,
    )
  }

  GetReasonValues() {
    return this.http.get(this.base_url + 'Login/getresaontype')
  }

  getattenvalues(contactId, currdate) {
    return this.http.get(
      this.base_url + 'Login/getattenvalues?contactId=' + contactId + '&currdate=' + currdate,
    )
  }

  GetEmpAttendance(contactId, currdate) {
    return this.http.get(
      this.base_url + 'Login/GetEmpAttendance?contactId=' + contactId + '&currdate=' + currdate,
    )
  }

  //Send To Store
  GetSTSorder(companyId, storeId, contactId, date) {
    return this.http.get(
      this.base_url +
        'STS/GetSTSorder?companyId=' +
        companyId +
        '&storeId=' +
        storeId +
        '&contactId=' +
        contactId +
        '&date=' +
        date,
    )
  }

  SaveSTS(payload) {
    return this.http.post(this.base_url + 'STS/AddSTS', payload)
  }

  STSupdate(payload) {
    return this.http.post(this.base_url + 'STS/UPSTS', payload)
  }

  ReceiveSTSupdate(OrdId) {
    return this.http.post(this.base_url + 'STS/ReceiveSTS', OrdId)
  }

  Getstsrefer(CompanyId, StoreId) {
    return this.http.get(
      this.base_url + 'STS/GetSTSReferBy?CompanyId=' + CompanyId + '&StoreId=' + StoreId,
    )
  }
  getstsaccstore(companyId) {
    return this.http.get(this.base_url + 'STS/GetAccStore?companyId=' + companyId)
  }

  // CREDIT

  GetRepaymentId(TransId, CompanyId) {
    return this.http.get(
      this.base_url + 'ERP/GetRepayByIdDirect?transId=' + TransId + '&companyId=' + CompanyId,
    )
  }

  SaveCreditEditPay(payload) {
    return this.http.post(this.base_url + 'ERP/CreditEdit', payload)
  }

  getInputvalues(CompanyId) {
    return this.http.get(this.base_url + 'ERP/GetInputValues?companyId=' + CompanyId)
  }
  Getcredit(
    CompanyId,
    billStatus,
    storeId,
    contId,
    contTypeId,
    creTypeId,
    FromAmt,
    ToAmt,
    Reference,
    fromdate,
    todate,
    transId,
  ) {
    return this.http.get(
      this.base_url +
        'ERP/GetCreditData?CompanyId=' +
        CompanyId +
        '&billStatus=' +
        billStatus +
        '&storeId=' +
        storeId +
        '&contId=' +
        contId +
        '&contTypeId=' +
        contTypeId +
        '&creTypeId=' +
        creTypeId +
        '&FromAmt=' +
        FromAmt +
        '&ToAmt=' +
        ToAmt +
        '&Reference=' +
        Reference +
        '&fromdate=' +
        fromdate +
        '&todate=' +
        todate +
        '&transId=' +
        transId,
    )
  }

  SaveCredit(payload) {
    return this.http.post(this.base_url + 'ERP/SaveCredit', payload)
  }

  GetCreditDetails(transactionId) {
    return this.http.get(this.base_url + 'ERP/GetDetailbyId?Id=' + transactionId)
  }
  GetRepay(contactid, CompanyId) {
    return this.http.get(
      this.base_url + 'ERP/GetRepayById?Id=' + contactid + '&companyId=' + CompanyId,
    )
  }
  DeleteCreditPay(delTransid, delBillid) {
    return this.http.get(
      this.base_url + 'ERP/DeletePay?transid=' + delTransid + '&billid=' + delBillid,
    )
  }
  SaveRepay(payload) {
    return this.http.post(this.base_url + 'ERP/repay', payload)
  }

  GetRepayIndex(
    CompanyId,
    storeId,
    contId,
    contTypeId,
    FromAmt,
    ToAmt,
    Reference,
    fromdate,
    todate,
    transId,
  ) {
    return this.http.get(
      this.base_url +
        'ERP/CreditRepayIndex?companyId=' +
        CompanyId +
        '&storeId=' +
        storeId +
        '&contId=' +
        contId +
        '&contTypeId=' +
        contTypeId +
        '&FromAmt=' +
        FromAmt +
        '&ToAmt=' +
        ToAmt +
        '&Reference=' +
        Reference +
        '&fromdate=' +
        fromdate +
        '&todate=' +
        todate +
        '&transId=' +
        transId,
    )
  }

  RepayEdit(payload) {
    return this.http.post(this.base_url + 'ERP/EditRepay', payload)
  }

  GetRepayEdit(TransId, ContId, CompanyId) {
    return this.http.get(
      this.base_url +
        'ERP/GetRepayEditById?TransId=' +
        TransId +
        '&ContId=' +
        ContId +
        '&companyId=' +
        CompanyId,
    )
  }

  RepayDetails(TransId) {
    return this.http.get(this.base_url + 'ERP/CreditDetilRepay?id=' + TransId)
  }

  DeleteRepaydata(transid, companyId, amount) {
    return this.http.get(
      this.base_url +
        'ERP/DeleteRepaydata?transid=' +
        transid +
        '&companyId=' +
        companyId +
        '&amount=' +
        amount,
    )
  }

  GetbankaccountStore(CompanyId, StoreId) {
    return this.http.get(
      this.base_url + 'ERP/GetBankAccountsByStore?companyId=' + CompanyId + '&storeId=' + StoreId,
    )
  }

  // Storepaymenttype----------------

  getStorePaymentType(StoreId) {
    return this.http.get(
      this.biz1_sap + 'StorePytTypes/getStorePaymentType_Retail?storeId=' + StoreId,
    )
  }

  AddStorepayment(spt) {
    return this.http.post(this.local_url + 'insertSpt_Retail', spt)
  }

  UpdateStorepayment(paymentType) {
    return this.http.post(this.local_url + 'updateSpt_Retail', paymentType)
  }

  StorePaymentDeactive(Id) {
    return this.http.get(this.local_url + 'StorePymtDeactive?id=' + Id)
  }
  // Category active

  //Category

  GetCategory(CompanyId, type) {
    return this.http
      .get(this.biz1_sap + 'Category/getcategories?CompanyId=' + CompanyId + '&type=' + type)
      .pipe(map(lowercaseKeys))
  }

  AddCategory(Category) {
    return this.http.post(this.local_url + 'addcategory', Category)
  }

  Updatecategory(Category) {
    return this.http.post(this.local_url + 'updatecategory', Category)
  }

  Categoryupdate(Id, active) {
    return this.http.get(this.local_url + 'UpdatecatAct?Id=' + Id + '&active=' + active)
  }

  //Getproduct

  GetProduct(CompanyId) {
    return this.http.get(this.biz1_sap + 'Product/GetProducts?companyId=' + CompanyId)
  }

  //Products------------
  GetProd(CompanyId) {
    return this.http.get(this.biz1_sap + 'Product/getProducts_retail?companyId=' + CompanyId)
  }

  importProduct(Id, data) {
    return this.http.post(this.biz1_sap + 'Product/ImportProduct?companyId=' + Id, data)
  }

  GetProductTypes() {
    return this.http.get(this.biz1_sap + 'Product/GetProductTypes')
  }

  GetUnits() {
    return this.http.get(this.biz1_sap + 'Product/GetUnits')
  }

  // getfactorystores(CompanyId) {
  //   return this.http.get(this.base_url + 'Menu/GetFactoryStore?companyId=' + CompanyId)
  // }

  productActupdate(Id, active, CompanyId) {
    return this.http.get(
      this.biz1_sap +
        'Product/UpdateProdAct?Id=' +
        Id +
        '&active=' +
        active +
        '&CompanyId=' +
        CompanyId,
    )
  }

  GetProductEditInd(prodid, companyId) {
    return this.http.get(
      this.biz1_sap + 'Product/GetProductEditInd?prodid=' + prodid + '&companyId=' + companyId,
    )
  }

  Addproduct(product) {
    return this.http.post(this.biz1_sap + 'Product/insertProduct_Retail', product)
  }

  UpdateProduct(product) {
    return this.http.post(this.biz1_sap + 'Product/updateProduct_Retail', product)
  }

  //Add Location

  getLocation(CompanyId) {
    return this.http.get(this.biz1_sap + 'Store/getLocation_Reatil?companyId=' + CompanyId)
  }

  //Vendors---------------------------
  GetVendor(CompanyId) {
    return this.http.get(this.local_url + 'getVendor_retail?companyId=' + CompanyId)
  }

  AddVendor(vendor) {
    return this.http.post(this.base_url + 'Menu/insertVendor_Retail', vendor)
  }

  UpdateVendor(vendor) {
    return this.http.post(this.base_url + 'Menu/updateVendor_retail', vendor)
  }

  AddLocation(locate) {
    return this.http.post(this.biz1_sap + 'Store/insertLocation_Retail', locate)
  }

  // UpdateLocation(location) {
  //   return this.http.post(this.biz1_sap + 'Store/updateLocation_Retail', location)
  // }

  DeActivate(sid) {
    return this.http.get(this.local_url + 'updateisActive_stores_Retail?sid=' + sid)
  }

  //Option-Group--------------------

  Getoptiongroups(CompanyId) {
    return this.http.get(this.base_url + 'Menu/Get?companyId=' + CompanyId)
  }

  optionsActive(Id, active) {
    return this.http.get(this.base_url + 'Menu/UpdateAct?Id=' + Id + '&active=' + active)
  }

  Editoption(Id) {
    return this.http.get(this.base_url + 'Menu/GetById?Id=' + Id)
  }

  getCategorymapped(CompanyId) {
    return this.http.get(this.base_url + 'Menu/CategoryIndex?companyid=' + CompanyId)
  }

  getMapedProducts(CompanyId, optionGroupId) {
    return this.http.get(
      this.base_url +
        'Menu/getMapedProducts?companyId=' +
        CompanyId +
        '&optionGroupId=' +
        optionGroupId,
    )
  }

  optionBulksave(OptionGroupId, CompanyId, ProductIds) {
    return this.http.post(
      this.base_url + 'Menu/BulkSave?OptionGroupId=' + OptionGroupId + '&CompanyId=' + CompanyId,
      ProductIds,
    )
  }

  Saveoption(data) {
    return this.http.post(this.base_url + 'Menu/CreateOption', data)
  }

  UpdateOption(data) {
    return this.http.post(this.base_url + 'Menu/Update', data)
  }

  // Store-Products Modified

  // getstrproducts(
  //   CompanyId: number,
  //   storekey: string[],
  //   productId: number,
  //   categoryId: number,
  //   pageNumber: number,
  //   pageSize: number
  // ): Observable<any> {

  //   const params: any = {
  //     CompanyId: String(CompanyId),
  //     storekey:
  //       storekey && storekey.length && !storekey.includes('')
  //         ? storekey.join(',')
  //         : '',
  //     productId: productId ? String(productId) : '0',
  //     categoryId: categoryId ? String(categoryId) : '0',
  //     PageNumber: String(pageNumber),
  //     PageSize: String(pageSize)
  //   };

  //   return this.http.get<any>(
  //     `${this.biz1_sap}Product/GetStoreProd`,
  //     { params }
  //   );
  // }

  STRprodUpdate(payload) {
    return this.http.post(this.local_url + 'UpdateSTRPrice', payload)
  }

  deleteStrProd(SptId) {
    return this.http.get(this.biz1_sap + 'Product/DeleteStoreProduct?SptId=' + SptId)
  }

  // UpdateStoreoption(payload) {
  //   return this.http.post(this.base_url + 'Menu/UpdateOPTPrice', payload)
  // }

  //TaxGroup

  Gettax(CompanyId) {
    return this.http.get(this.biz1_sap + 'TaxGroup/GetTaxGrp?CompanyId=' + CompanyId)
  }

  Addtax(taxgroup) {
    return this.http.post(this.local_url + 'AddTaxGrp', taxgroup)
  }

  Updatetax(taxgroup) {
    return this.http.post(this.local_url + 'UpdateTaxGrp', taxgroup)
  }

  //Stock Transfer
  SaveInitialStock(payload) {
    return this.http.post(this.base_url + 'Stock/AddInitialStock', payload)
  }

  DeleteStkUpd(StkUpdId, action) {
    return this.http.get(
      this.base_url + 'Stock/DeleteStkUpde?StkUpdId=' + StkUpdId + '&Checkdatas=' + action,
    )
  }

  DeleteStockUpdate(Id) {
    return this.http.get(this.base_url + 'Stock/DeleteDraftItem?Id=' + Id)
  }

  GetUpdateMoreValues(StoreId, date, catId, supId, prodname, proddes, action3) {
    return this.http.get(
      this.base_url +
        'Stock/GetUpdateMore?storeId=' +
        StoreId +
        '&date=' +
        date +
        '&catId=' +
        catId +
        '&supId=' +
        supId +
        '&prodname=' +
        prodname +
        '&proddes=' +
        proddes +
        '&Checkdata=' +
        action3,
    )
  }

  GetStockValues(
    CompanyId,
    StoreId,
    MinStr,
    MinEnd,
    MaxStr,
    MaxEnd,
    Supplierid,
    UsageCheck,
    NumberRecord,
    prodid,
  ) {
    return this.http.get(
      this.base_url3 +
        'Stock/GetStocks?companyId=' +
        CompanyId +
        '&storeid=' +
        StoreId +
        '&minstr=' +
        MinStr +
        '&minend=' +
        MinEnd +
        '&maxstr=' +
        MaxStr +
        '&maxend=' +
        MaxEnd +
        '&supplierid=' +
        Supplierid +
        '&usagecheck=' +
        UsageCheck +
        '&numRecord=' +
        NumberRecord +
        '&prodId=' +
        prodid,
    )
  }

  SaveStoctReOrder(payload) {
    return this.http.post(this.base_url + 'Stock/SaveReOrder', payload)
  }

  GetStockUpdateValues(StoreId, date, catId, supId, prodname, proddes) {
    return this.http.get(
      this.base_url +
        'Stock/GetStockUpdIndex?storeId=' +
        StoreId +
        '&date=' +
        date +
        '&catId=' +
        catId +
        '&supId=' +
        supId +
        '&prodname=' +
        prodname +
        '&proddes=' +
        proddes,
    )
  }

  SaveStockUpdate(payload) {
    return this.http.post(this.base_url + 'Stock/SaveStockDraft', payload)
  }

  GetAutoOrderUpdate(CompanyId, StoreId, Supplier, ordDate) {
    return this.http.get(
      this.base_url3 +
        'Stock/GetAutoOrdIndex?companyId=' +
        CompanyId +
        '&storeid=' +
        StoreId +
        '&supplierId=' +
        Supplier +
        '&ordDate=' +
        ordDate,
    )
  }

  GetStockStores(CompanyId, StoreId) {
    return this.http.get(
      this.base_url + 'Stock/GetSupplierStores?companyId=' + CompanyId + '&storeid=' + StoreId,
    )
  }

  SaveAutoOrder(payload) {
    return this.http.post(this.base_url + 'Stock/SaveAutoOrder', payload)
  }
  GetAutoIndexMain(CompanyId, StoreId, supplierId, frmdate, todate, OrdId) {
    return this.http.get(
      this.base_url +
        'Stock/GetAutoOrdIndexMain?companyId=' +
        CompanyId +
        '&storeid=' +
        StoreId +
        '&supplierId=' +
        supplierId +
        '&frmdate=' +
        frmdate +
        '&Todate=' +
        todate +
        '&OrdId=' +
        OrdId,
    )
  }
  deleteautoitem(itemid) {
    return this.http.get(this.base_url3 + 'Stock/DeleteOrdItemsAuto?itemid=' + itemid)
  }

  fetchDenominationEntries(storeid, date, companyid, entrytypeid) {
    return this.http.get(
      this.base_url2 +
        `Denomination/getDenomEntry?storeid=${storeid}&date=${date}&companyid=${companyid}&entrytypeid=${entrytypeid}`,
    )
  }

  denominationTypes() {
    return this.http.get(this.base_url2 + `Denomination/GetDenominationTypes`)
  }
  denomEntryReport(companyid: number, from: string, to: string, margin: number) {
    return this.http.get(
      this.base_url2 +
        `Denomination/denomReport_?companyid=${companyid}&from=${from}&to=${to}&margin=${margin}`,
    )
  }
  getStores(compId) {
    var formURL = this.base_url2
    var formURL = this.base_url2 + 'Stores/Get?CompanyId=' + compId
    return this.http.get(formURL)
  }

  saveopeningbalance(storeid, ob, ex) {
    return this.http.get(
      this.base_url2 +
        'Stores/OpeningBalance?storeid=' +
        storeid +
        '&openingbalance=' +
        ob +
        '&expense=' +
        ex,
    )
  }
  //m

  getRecOrders(
    indexType,
    companyId,
    storeId,
    date,
    fromDate,
    toDate,
    receiver,
    supplier,
    orderStatusId,
    Orderid,
    InvoiceNo,
    billStatusId,
  ) {
    return this.http.get(
      this.base_url +
        'ERP/getRecOrders' +
        '?indexType=' +
        indexType +
        '&companyId=' +
        companyId +
        '&storeId=' +
        storeId +
        '&date=' +
        date +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        '&receiver=' +
        receiver +
        '&supplier=' +
        supplier +
        '&orderStatusId=' +
        orderStatusId +
        '&Orderid=' +
        Orderid +
        '&InvoiceNo=' +
        InvoiceNo +
        '&billStatusId=' +
        billStatusId,
    )
  }

  GetSTStrans(indexType, companyId, storeId, sender, receiver, fromDate, toDate, transId) {
    return this.http.get(
      this.base_url +
        'STS/GetSTStrans' +
        '?indexType=' +
        indexType +
        '&companyId=' +
        companyId +
        '&storeId=' +
        storeId +
        '&sender=' +
        sender +
        '&receiver=' +
        receiver +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        '&transId=' +
        transId,
    )
  }

  //New IO Q
  DelteOrdItems(ItemId) {
    return this.http.get(this.base_url + 'ERP/DeleteItems?OiId=' + ItemId)
  }

  //KOT VJ
  GetKotIndex(CompanyId) {
    return this.http.get(this.biz1_sap + 'KOTGroup/GetIndexKOT?CompanyId=' + CompanyId)
  }

  SaveKot(data) {
    return this.http.post(this.biz1_sap + 'KOTGroup/CreateKOT', data)
  }

  UpdateKot(data) {
    return this.http.post(this.biz1_sap + 'KOTGroup/EditKOT', data)
  }

  KotIsEditable(Id, active, CompanyId) {
    return this.http.get(
      this.biz1_sap +
        'KOTGroup/UpdateKotAct?Id=' +
        Id +
        '&active=' +
        active +
        '&CompanyId=' +
        CompanyId,
    )
  }

  // deleteKot(Id){
  //   return this.http.get(this.biz1_sap + 'KOTGroup/DeleteKOT', Id)
  // }
  deleteKot(Id) {
    return this.http.get(this.local_url + 'DeleteKOT?Id=' + Id)
  }

  //------------------------------------------------------------------------------------------------------------
  //DUMMY
  getdbdata(dbnames) {
    return this.http.post(this.dburl + 'getdbdata', dbnames)
  }

  getpreorderbyinvoice(invoiceno, id) {
    return this.http.get(
      this.dburl + 'getpreorderby_invoiceno?invoiceno=' + invoiceno + '&id=' + id,
    )
  }

  getorderjson(orderid) {
    return this.http.get(this.base_url2 + 'Receipt/GetOrderJson?orderid=' + orderid)
  }

  // cancelorder(orderid, payload) {
  //   return
  // }

  getBarcodeProduct(CompanyId, storeId) {
    return this.http.get(
      this.base_url1 + 'Product/getbarcodeproduct?CompanyId=' + CompanyId + '&storeId=' + storeId,
    )
  }

  getstores(compid) {
    return this.http.get(this.base_url1 + 'Internal/getStoreList?CompanyId=' + compid)
  }

  getorder(ordId) {
    return this.http.post(this.base_url1 + 'Internal/getOrderList', ordId)
  }

  updateCustomer(payload) {
    return this.http.put(this.base_url1 + 'Customer/updateData', payload)
  }

  addCustomers(payload) {
    return this.http.post(this.base_url1 + 'Customer/addData', payload)
  }

  deleteItem(Id) {
    return this.http.post(this.base_url1 + 'Internal/DeleteOrder', Id)
  }

  getOrderIdinternal(OrdId) {
    return this.http.get(this.base_url1 + 'Internal/internalordbyid?orderid=' + OrdId)
  }

  getorderlist(storeId) {
    return this.http.get(
      this.base_url1 + 'Internal/getOrderList?storeId=' + storeId + '&numRecords=50',
    )
  }

  getstoreIdInternal(CompanyId, Id) {
    return this.http.get(
      this.base_url1 + 'Internal/GetstorebyId?CompanyId=' + CompanyId + '&Id=' + Id,
    )
  }

  getintprod(CompanyId, StoreId, testid) {
    return this.http.get(
      this.base_url1 +
        'Internal/GetInternalproduct?CompanyId=' +
        CompanyId +
        '&StoreId=' +
        StoreId +
        '&testid=' +
        testid,
    )
  }

  getstoreslist(companyid, storeid) {
    return this.http.get(
      this.base_url1 + 'Internal/getstoreslist?companyid=' + companyid + '&storeid=' + storeid,
    )
  }

  savestock(order) {
    return this.http.post(this.base_url1 + 'Internal/saveIntOrd', order)
  }

  getStockContainer(CompanyId, StoreId) {
    return this.http.get(
      this.base_url1 + 'Internal/getStockContainer?CompanyId=' + CompanyId + '&storeId=' + StoreId,
    )
  }

  getDispatchList(data) {
    return this.http.post(this.base_url1 + 'Internal/ReceiveDispatch', data)
  }

  Ordrecve(data) {
    return this.http.post(this.base_url1 + 'Internal/OrdReceive', data)
  }

  editInternalord(id) {
    return this.http.get(this.base_url1 + 'Internal/EditInternalOrd?id=' + id)
  }

  deletedata(Id) {
    return this.http.post(this.base_url1 + 'Internal/Delete', Id)
  }

  //-----------------------------------------------------------------------------------------------------------------------------------------------
  sapregistration(payload) {
    return this.http.post(this.biz1_sap + 'Login/Register', payload)
  }

  //BIZ1_SAP

  //DiningArea-----------------

  GetDiningArea(companyid, storeId) {
    return this.http
      .get(
        this.biz1_sap + 'DiningArea/GetDiningArea?companyid=' + companyid + '&storeId=' + storeId,
      )
      .pipe(map(lowercaseKeys))
  }

  AddDiningArea(payload) {
    return this.http.post(this.biz1_sap + 'DiningArea/AddDining', payload)
  }

  UpdateDining(payload) {
    return this.http.post(this.biz1_sap + 'DiningArea/UpdateDining', payload)
  }

  //WEB auth
  Update_Dining(payload) {
    return this.http.post(this.local_url + 'UpdateDiningArea_WEB', payload)
  }
  DiningArea(CompanyId, StoreId) {
    return this.http
      .get(this.local_url + 'DineIn_GET_WEB?CompanyId=' + CompanyId + '&StoreId=' + StoreId)
      .pipe(map(lowercaseKeys))
  }

  InsertDining(payload) {
    return this.http.post(this.local_url + 'Dining_POST_WEB', payload)
  }

  DiningTables(DiningAreaId: number, storeid: number) {
    const url =
      this.local_url + 'DiningTable_View_WEB?DiningAreaId=' + DiningAreaId + '&Storeid=' + storeid
    console.log('Calling DiningTables API:', url)

    return this.http.get(url).pipe(
      catchError(error => {
        console.error('Error in DiningTables API:', error)
        return throwError(error)
      }),
    )
  }

  GetProductWithPagination(
    CompanyId: number,
    Page: number,
    PageSize: number,
    isActive: boolean | null = null,
      ParentStoreId:number,
    searchTerm: string = '',
  
  ): Observable<any> {
    let params: any = {
      CompanyId: CompanyId.toString(),
      PageNumber: Page.toString(),
      PageSize: PageSize.toString(),
      ParentStoreId: ParentStoreId.toString(),
    }

    if (isActive !== null && isActive !== undefined) {
      params.IsActive = isActive.toString()
    }
    if (searchTerm && searchTerm.trim() !== '') {
      params.SearchTerm = searchTerm.trim()
    }

    console.log('API Params:', params)

    return this.http
      .get(this.local_url + 'Get_products_WEB_Paginated_NEW', { params })
      .pipe(map(lowercaseKeys))
  }
  AddProduct_post(payload: any) {
    return this.http.post(this.local_url + 'Addproducts_post_WEB', payload)
  }

  AddProduct_post_NEW(payload: any) {
    return this.http.post(this.local_url + 'Addproducts_post_WEB_NEW', payload)
  }

  importproductAdd(payload: any) {
    return this.http.post(this.local_url + 'Addproducts_import_WEB', payload)
  }

  importproductAdd_NEW(payload: any) {
    return this.http.post(this.local_url + 'Addproducts_import_WEB_NEW', payload)
  }

  GetPOS_Stores(CompanyId: number) {
    return this.http.get(this.local_url + 'Get?CompanyId=' + CompanyId)
  }

  GetPOS_Stores_NEW(CompanyId: number,ParentStoreId:number) {
    return this.http.get(this.local_url + 'Get_NEW?CompanyId=' + CompanyId+'&ParentStoreId='+ParentStoreId)
  }

  GetProducts_get(Id, CompanyId) {
    return this.http
      .get(this.local_url + 'GetProductById_WEB?Id=' + Id + '&CompanyId=' + CompanyId)
      .pipe(map(lowercaseKeys))
  }

  UpdateProduct_WEB(productData: any) {
    return this.http.post(this.local_url + 'UpdateProduct_WEB', productData)
  }

   UpdateProduct_WEB_NEW(productData: any) {
    return this.http.post(this.local_url + 'UpdateProduct_WEB_NEW', productData)
  }
  Get_All_products(CompanyId: number) {
    return this.http
      .get(this.local_url + 'Get_All_products_WEB?CompanyId=' + CompanyId)
      .pipe(map(lowercaseKeys))
  }

  AddLocation_WEB(locate) {
    return this.http.post(this.local_url + 'AddLocation_WEB', locate)
  }
  validateUserPin_WEB(data: any): Observable<any> {
    return this.http.post(this.local_url + 'ValidateUserPin', data)
  }

 getstrproducts_WEB(
  companyId: number,
  storeIds: string[] = [],
  productId: number,
  categoryId: number,
  kotGroupId: number,
): Observable<any> {

  const storeIdsParam = storeIds.length > 0 ? storeIds.join(',') : null;

  const params: any = {
    CompanyId: companyId.toString(),
    StoreIds: storeIdsParam,
  };

  if (productId > 0)
    params.ProductId = productId;

  if (categoryId > 0)
    params.CategoryId = categoryId;

  if (kotGroupId > 0)
    params.KotGroupId = kotGroupId;

  Object.keys(params).forEach(key => params[key] == null && delete params[key]);

  return this.http
    .get(`${this.local_url}Get_Storeproducts_WEB_NEW`, { params })
    .pipe(map(lowercaseKeys));
}

  updateStoreProductStatus(data: any): Observable<any> {
    return this.http.post(`${this.local_url}Update_Sp_Status_WEB`, data)
  }
  UpdateSpPrice(payload: any) {
    return this.http.post(this.local_url + 'Update_StoreProd_Price_WEB', payload)
  }

  get_location(companyId: number) {
    return this.http
      .get(this.local_url + 'GetLocation_WEB?CompanyId=' + companyId)
      .pipe(map(lowercaseKeys))
  }

  UpdateLocation(location) {
    return this.http.post(this.local_url + 'UpdateLocation_WEB', location)
  }
  validateStoreName(payload: any) {
    return this.http.post(this.local_url + 'ValidateStoreName_WEB', payload)
  }
  GetTaxGrp(CompanyId: number) {
    return this.http
      .get(this.local_url + 'get_taxgroup_WEB?CompanyId=' + CompanyId)
      .pipe(map(lowercaseKeys))
  }
  Get_Category(CompanyId: number) {
    return this.http
      .get(this.local_url + 'Get_Category_WEB?CompanyId=' + CompanyId)
      .pipe(map(lowercaseKeys))
  }
  Get_storepayments(StoreId: number) {
    return this.http
      .get(this.local_url + 'Get_StorePayments_WEB?StoreId=' + StoreId)
      .pipe(map(lowercaseKeys))
  }
  Get_ProductTypes(CompanyId: number) {
    return this.http
      .get(this.local_url + 'Get_ProductTypes_WEB?CompanyId=' + CompanyId)
      .pipe(map(lowercaseKeys))
  }
  Get_Units(CompanyId: number) {
    return this.http
      .get(this.local_url + 'Get_Units_WEB?CompanyId=' + CompanyId)
      .pipe(map(lowercaseKeys))
  }
  Get_KotGrp(CompanyId: number) {
    return this.http
      .get(this.local_url + 'Get_KotGrp_WEB?CompanyId=' + CompanyId)
      .pipe(map(lowercaseKeys))
  }

  Update_KotGrp(payload: any) {
    console.log('Api is called')
    return this.http.post(this.local_url + 'Edit_Kot_WEB', payload)
  }
  save_kotgrp(payload: any) {
    return this.http.post(this.local_url + 'Save_Kot_WEB', payload)
  }

  UpdateTaxPOS(id: number, isPOS: boolean) {
    // console.log('API called with id:', id, 'and isPOS:', isPOS);
    return this.http.get(this.local_url + 'UpdateIsPOS?id=' + id + '&isPOS=' + isPOS)
  }

  Update_IsActiveKotGrp(id: number, isActive: boolean) {
    return this.http.get(this.local_url + 'UpdateIsActiveKotGrp?id=' + id + '&isActive=' + isActive)
  }

  UpdateSPIsactive(id: number, Price: number) {
    return this.http.get(this.local_url + 'UpdateSPIsactive?id=' + id + '&price=' + Price)
  }

  getProductsadvanced(companyId: number,StoreId:any, searchTerm: string = '', categoryId: number) {
    return this.http
      .get(
        this.local_url +
          'getProductsadvanced?CompanyId=' +
          companyId +
           '&StoreId=' +
            StoreId +
          '&SearchTerm=' +
          searchTerm +
          '&CategoryId=' +
          categoryId,
      )
      .pipe(map(lowercaseKeys))
  }

  addStoreCategory(payload: any) {
    return this.http.post(this.local_url + 'AddStoreCategory', payload)
  }

  getStoreCategories(storeid: number) {
    return this.http
      .get(this.local_url + 'GetStoreCategories?StoreId=' + storeid)
      .pipe(map(lowercaseKeys))
  }

  updatestoreCategoryStatus(id: number, isActive: boolean) {
    return this.http.get(
      this.local_url + 'UpdateStoreCategoryStatus?id=' + id + '&active=' + isActive,
    )
  }

  updateStoreCategory(payload: any) {
    return this.http.post(this.local_url + 'UpdateStoreCategory', payload)
  }


  UpdateSingleKotGroup(payload: {
  StoreProductId: number;
  KotGroupId: number;
}) {
  return this.http.post(
    `${this.local_url}UpdateSingleKotGroup`,
    payload
  );
}
    UpdateMultipleKotGroup(payload: {
  StoreProductIds: string;
  KotGroupId: number;
}) {
  return this.http.post(
    `${this.local_url}UpdateMultipleKotGroup`,
    payload
  );
}
}
